export const getPlacementCycleLabel = cycle => cycle?.placement_cycle_short || cycle?.placement_cycle || ''

export const getJobCycleIds = job => Array.isArray( job?.placement_cycle_ids )
    ? job.placement_cycle_ids
    : ( job?.placement_cycles || [] ).map( cycle => cycle.placement_cycle )

export const formatJobCycles = ( job, cycles = [] ) => {
    const labels = getJobCycleIds( job ).map( id => {
        const cycle = cycles.find( item => item.placement_cycle === id )
            || job?.placement_cycles?.find( item => item.placement_cycle === id )
        return getPlacementCycleLabel( cycle ) || id
    } )

    if ( labels.length > 1 )
        return `${labels[0]}, +${labels.length - 1} more`
    return labels.join( ", " )
}

export const getStudentRegistrationScope = record => {
    const assignmentId = record?.student_assignment_id
    if ( assignmentId ) return { student_assignment_id: assignmentId }
    return record?.placement_cycle_id ? { placement_cycle_id: record.placement_cycle_id } : {}
}

export const getStudentJobKey = job => `${job.job_id}:${job.student_assignment_id || job.placement_cycle_id || ''}`

export const getStudentCompanyPath = companyId => `/placements/companies/${encodeURIComponent( companyId )}`

export const getStudentJobPath = job => {
    const params = new URLSearchParams()
    if ( job.student_assignment_id ) params.set( 'assignment_id', job.student_assignment_id )
    else if ( job.placement_cycle_id ) params.set( 'placement_cycle_id', job.placement_cycle_id )
    const query = params.toString()
    return `/placements/jobs/${encodeURIComponent( job.job_id )}${query ? `?${query}` : ''}`
}
